<app-nav-bar></app-nav-bar>
<main class="main-container container">
  <div class="select-project">
    <div class="col-md-6">
      <label for="projects" class="form-label">{{'SELECT_CLASS' | translate}}</label>
      <select class="form-select" [(ngModel)]="selectedProjectId" (change)="onProjectChange($event)">
        <option selected disabled hidden>
          {{'SELECT-OPTION' | translate}}
        </option>
        <option *ngFor="let project of projects" [value]="project.projectId">
          {{ project.projectName }}
        </option>
      </select>
    </div>
     <div class="col-md-6">
      <label for="resources" class="form-label">{{'SELECT_TEACHER' | translate}}</label>
      <select class="form-select" [(ngModel)]="selectedResourceId" (change)="onResourceChange($event)">
        <option selected disabled hidden>
          {{'SELECT-OPTION' | translate}}
        </option>
        <option *ngFor="let resource of projectResources" [value]="resource.resourceId">
          {{ resource.resourceName }}
        </option>
      </select>
    </div>
  </div>
  <full-calendar [options]="calendarOptions" id="calendar" class="container main-container"></full-calendar>
</main>

<div class="modal" *ngIf="showModal">
  <div class="modal-content">

    <div class="modal-header">
      <h1 class="modal-title title">{{'SCHEDULE_APPOINTMENT' | translate}}</h1>
      <button class="btn-close" (click)="closeModal()">&times;</button>
    </div>

    <header class="date-time">
      <h2 class="modal-time">{{ selectedEvent?.formattedDate }}</h2>
      <p class="modal-time">{{ selectedEvent?.formattedTime }}</p>
      <button type="button" class="custom-button btn-outline-secondary" (click)="openClientModal()">
        {{'SELECT_CLIENT' | translate}}
      </button>
    </header>

    <form [formGroup]="bookingForm" class="modal-form">
      <div class="form-group">
        <label for="customerName">{{'NAME' | translate}}:</label>
        <input id="customerName" formControlName="customerName" type="text" placeholder="{{'NAME' | translate}}"
          required />
      </div>
      <div class="form-group">
        <label for="customerEmail">{{'EMAIL' | translate}}:</label>
        <input id="customerEmail" formControlName="customerEmail" type="email" placeholder="{{'EMAIL' | translate}}"
          required />
      </div>
      <div class="form-group">
        <label for="customerNationalId">{{ 'ID_NUMBER' | translate }}</label>
        <input id="customerNationalId" formControlName="customerNationalId" type="text"
          placeholder="{{ 'ID_NUMBER' | translate }}" required />
      </div>
      <div class="form-group">
        <label for="customerPhone">{{ 'PHONE' | translate }}</label>
        <input id="customerPhone" formControlName="customerPhone" type="text" placeholder="{{ 'PHONE' | translate }}"
          required />
      </div>
      <div class="form-group" *ngIf="projectResources.length > 1">
        <label for="resourceSelect">{{ 'SELECT_RESOURCE' | translate }}:</label>
        <select id="resourceSelect" class="form-select" [(ngModel)]="selectedResourceId" [ngModelOptions]="{standalone: true}">
          <option *ngFor="let resource of projectResources" [value]="resource.resourceId">
            {{ resource.resourceName }}
          </option>
        </select>
      </div>
    </form>

    <p *ngIf="isPrivateProject && selectedClient" class="text-center mt-2" [ngClass]="{
    'text-success': canSchedulePrivate,
    'text-danger': !canSchedulePrivate && !isCheckingSessions
  }">
      <ng-container *ngIf="isCheckingSessions">
        <span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
        Cargando sesiones disponibles...
      </ng-container>

      <ng-container *ngIf="!isCheckingSessions && canSchedulePrivate">
        Tiene {{ availableSessions }} sesiones disponibles para agendar.
      </ng-container>

      <ng-container *ngIf="!isCheckingSessions && !canSchedulePrivate">
        El cliente no tiene sesiones disponibles para agendar.
      </ng-container>
    </p>

    <div class="buttons-footer">
      <div class="modal-button">
        <button (click)="blockHours()" class="btn btn-saved">
          {{ 'BLOCK_HOURS' | translate }}
        </button>
      </div>

      <div class="modal-button">
        <button (click)="createBookings()" class="custom-button btn-outline-primary primary-btn"
          [disabled]="isScheduleDisabled">
          {{ 'SCHEDULE_APPOINTMENT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="client-modal" *ngIf="showClientModal">
  <div class="client-modal-content">
    <div class="client-modal-header">
      <h2 class="client-modal-title title">{{'SELECT_CLIENT' | translate}}</h2>
      <button class="btn-close" (click)="closeClientModal()">&times;</button>
    </div>

    <div class="client-modal-body">
      <input type="text" class="client-search-input" placeholder="Buscar cliente..." [formControl]="searchControl" />
      <div *ngIf="loading">{{'LOADING_CLIENTS' | translate}}</div>
      <div *ngIf="!loading && clients.length === 0">{{'NO_CLIENTS' | translate}}</div>

      <ul *ngIf="!loading" class="client-list">
        <li *ngFor="let clients of clients" class="client-list-item">
          <div class="client-card">
            <div class="client-info">
              <strong>{{ clients.firstName }} {{ clients.lastName }}</strong><br />
              <small>{{ clients.email }}</small>
            </div>
            <button type="button" class="custom-button btn-outline-primary primary-btn"
              (click)="selectClient(clients)">Seleccionar</button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<div *ngIf="isErrorModalVisible" class="modal beneficiary-modal-dialog" id="errorModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{'ERROR_BOOKING' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeModal()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isSuccessModalVisible" class="modal beneficiary-modal-dialog" id="successBookings" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{ 'SUCCESS' | translate }}</h3>
        <p class="text-center">{{'APPOINTMENT_SUCCESSFULLY' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger confirm-btn" (click)="closeModal()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>


<app-loading-modal [visible]="showStatusModal" [status]="statusModalType" [message]="statusModalMessage"
  (closed)="onModalClosed()">
</app-loading-modal>

<app-confirmation-modal *ngIf="modalCancelHours" [title]="'BLOCK_ALL_DAY' | translate"
  [message]="'SURE_BLOCK_DAY' | translate" [confirmText]="'BLOCK_DAY' | translate" [cancelText]="'CANCEL' | translate"
  (response)="handleCancelConfirmation($event)">
</app-confirmation-modal>
